/** @jsx jsx */
import { navigate } from 'gatsby'
import { jsx, Button } from 'theme-ui'
import openInNewTab from '../../utils/openInNewTab'
import PropTypes from 'prop-types'

const CustomButton = ({ data, id }) => {
  const { text, url } = data.fields
  return (
    <Button
      id={id}
      sx={{
        marginBottom: '24px',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={() => {
        url.includes('www') || url.includes('http')
          ? openInNewTab(url)
          : navigate(url)
      }}
    >
      {text}
    </Button>
  )
}

CustomButton.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
}

export default CustomButton
